var _rect, _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCompletedBag(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 50,
    rx: 10,
    fill: "#E8F4EC"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.9987 33.1673C27.576 33.1673 29.6654 31.078 29.6654 28.5007C29.6654 25.9233 27.576 23.834 24.9987 23.834C22.4214 23.834 20.332 25.9233 20.332 28.5007C20.332 31.078 22.4214 33.1673 24.9987 33.1673Z",
    stroke: "#1C8F3C",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.1797 28.5008L23.938 29.2591C24.1597 29.4808 24.5214 29.4924 24.743 29.2708L26.8197 27.3574",
    stroke: "#1C8F3C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21.4983 36.6673H28.4983C33.1883 36.6673 34.0283 34.789 34.2733 32.5023L35.1483 25.5023C35.4633 22.6557 34.6467 20.334 29.665 20.334H20.3317C15.35 20.334 14.5333 22.6557 14.8483 25.5023L15.7233 32.5023C15.9683 34.789 16.8083 36.6673 21.4983 36.6673Z",
    stroke: "#1C8F3C",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M19.75 19.9491V18.8174C19.75 16.1924 21.8617 13.6141 24.4867 13.3691C27.6133 13.0657 30.25 15.5274 30.25 18.5957V20.2057",
    stroke: "#1C8F3C",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompletedBag);
export default __webpack_public_path__ + "static/media/completed-bag.c0337fd4378624dc28d796730bfa1027.svg";
export { ForwardRef as ReactComponent };